module.exports = __webpack_public_path__ + "static/media/LogoBlue.02186467.png";